import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { I as d, a as u } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import "react";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { I as x } from "./icon-button-UFwDzoPr.mjs";
const s = ({
  a11yLabel: a,
  onClick: t,
  icon: r,
  className: n
}) => /* @__PURE__ */ e(
  x,
  {
    "aria-label": a,
    className: o(n, "aspect-auto w-100"),
    icon: r,
    onClick: t,
    size: "small",
    theme: "outlined_basic",
    title: a
  }
), c = (a) => "0".repeat(Math.max(2, String(a).length)), i = ({ align: a = "left", bold: t = !1, value: r }) => /* @__PURE__ */ e("span", { className: `min-w-28 flex-1 truncate text-${a} ${t ? "font-bold" : ""}`.trim(), children: typeof r == "number" ? String(r).padStart(2, "0") : r }), f = ({
  currentPage: a,
  totalPages: t,
  onClickPrevious: r,
  onClickNext: n,
  className: m
}) => /* @__PURE__ */ l("div", { className: o(m, "flex items-center justify-center"), children: [
  /* @__PURE__ */ e(
    s,
    {
      a11yLabel: "이전",
      icon: /* @__PURE__ */ e(d, { className: "size-20 text-text-neutral-main" }),
      onClick: r
    }
  ),
  /* @__PURE__ */ l("div", { className: "mx-4 flex min-w-68 max-w-158 flex-col items-center justify-center tabular-nums typography-body-14-regular", children: [
    /* @__PURE__ */ l("div", { className: "flex w-full text-text-neutral-main", children: [
      /* @__PURE__ */ e(i, { align: "right", bold: !0, value: a }),
      /* @__PURE__ */ e("span", { className: "mx-4", children: "/" }),
      /* @__PURE__ */ e(i, { value: t })
    ] }),
    /* @__PURE__ */ l("div", { "aria-hidden": "true", className: "h-0 overflow-hidden whitespace-nowrap", children: [
      /* @__PURE__ */ e(i, { align: "right", bold: !0, value: c(t) }),
      /* @__PURE__ */ e("span", { className: "mx-4", children: "/" }),
      /* @__PURE__ */ e(i, { value: c(t) })
    ] })
  ] }),
  /* @__PURE__ */ e(
    s,
    {
      a11yLabel: "다음",
      icon: /* @__PURE__ */ e(u, { className: "size-20 text-text-neutral-main" }),
      onClick: n
    }
  )
] });
f.displayName = "NDS.PageController";
export {
  f as P
};
